import React from 'react';
import PropTypes from 'prop-types';
import Trigger from '../containers/Trigger';
import FlyoutMessage from './FlyoutMessage';
import { select } from '@cvent/nucleus-dynamic-css';
/**
Display info flyout on hover of Trigger Element
**/

export default class InfoFlyout extends React.Component {
  static displayName = 'InfoFlyout';
  static propTypes = {
    /** arrayOf used to make sure at least 2 childern are being passed in. */
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    /** Flag to apply the mouse x/y postion to the triggered child object */
    useEventPosition: PropTypes.bool,
    /** Which direction does it flow from. */
    flyoutDirection: PropTypes.oneOf(['horizontal', 'vertical']),
    /** Allows a user to override the direction in which a flyout flows */
    forceDirection: PropTypes.shape({
      horz: PropTypes.oneOf(['left', 'right', 'center']),
      vert: PropTypes.oneOf(['top', 'bottom'])
    }),
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Style applied to the Trigger component. */
      trigger: PropTypes.object,
      /** Style applied to the FlyoutMessage component. */
      flyout: PropTypes.object
    })
  };
  static defaultProps = {
    flyoutDirection: 'horizontal',
    forceDirection: {
      vert: null,
      horz: null
    },
    useEventPosition: false
  };
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Trigger
        {...this.props}
        {...select(this.props, 'trigger')}
        ref="trigger"
        useEventPosition={this.props.useEventPosition}
      >
        {this.props.children[0]}
        <FlyoutMessage
          flyoutDirection={this.props.flyoutDirection}
          forceDirection={this.props.forceDirection}
          {...select(this.props, 'flyout')}
        >
          {this.props.children[1]}
        </FlyoutMessage>
      </Trigger>
    );
  }
}
